import features = require("diy/util/features");
import websiteData = require("diy/util/websiteData");

import NotificationApi from "diy/toolbar/notificationNG/Api";
import NotificationType from "diy/toolbar/notificationNG/definitions/Type";

type NotPublishedData = {
    triggerShow: boolean;
    show: boolean;
};

type MaintenanceMode = {
    getState: () => boolean;
    isFirstPublish: () => boolean;
};

let maintenanceMode = require("diy/maintenanceMode/maintenanceMode") as MaintenanceMode;

export class App {
    init() {
        NotificationApi.schedule(() => {
            let notPublishedData = websiteData.getNotificationData<NotPublishedData>("notPublished");

            if (!features("domainConnected")
                || !maintenanceMode.getState()
                || !maintenanceMode.isFirstPublish()
                || !notPublishedData.show) {

                NotificationApi.deleteOne(
                    NotificationType.NOT_PUBLISHED
                );

            } else if (notPublishedData.triggerShow) {
                NotificationApi.pushOne({
                    type: NotificationType.NOT_PUBLISHED,
                    dismissed: false,
                    deleted: false
                });
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/not-published/App.ts
 **/